export default __webpack_public_path__ + "static/media/27.16a3fe91.png";